export interface Promotion {
    id: number;
    store_id: number;
    name: string;
    description: string;
    blogOnly: boolean;
    startDate: string;
    endDate: string;
}

// Calendar dates are passed unchanged: no timezone conversion or time fields.
export const localPromotionDate = (value: string) => value.slice(0, 10)
export const promotionDate = (value: string) => new Date(`${localPromotionDate(value)}T00:00:00`)
export const formatPromotionDate = (value: string) => promotionDate(value).toLocaleDateString('ru-RU', {day: 'numeric', month: 'short', year: 'numeric'})
export const promotionToday = () => new Date().toISOString().slice(0, 10)
